import styled from "styled-components";
export const Styles = styled.div`
  .selected-logo-preview {
    position: relative;
    width: 200px;
    height: 200px;
    margin: 0 auto;
  }

  .logo-preview-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .logo-remove-button {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(255, 255, 255, 0.8);
  }

  .upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px;
    border: 2px dashed;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.3s ease;
  }

  .upload-placeholder:hover {
    border-color: primary.main;
  }
  .logo-container {
    margin-top: 30px;
    .switcher {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0;
    }
    .logo-ways-container {
      display: flex;
      flex-direction: row;
      gap: 40px;
      @media (max-width: 1200px) {
        align-items: center;
        flex-direction: column;
      }
      position: relative;
      justify-content: space-between;
      width: 100%;
      .custom-logo {
        display: flex;
        justify-content: center;
        border-radius: 5px;
        align-items: center;
        height: 300px;
        text-align: center;
        position: relative;
        border: #303030 solid 1px;
        .files {
          opacity: 0;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        .selected-logo-container {
          position: relative;
          width: 80%;
          height: 80%;
          border-radius: 5px;
          overflow: hidden;
          .selected-logo-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 5px;
          }
          .selected-logo-remove {
            position: absolute;
            top: 5px;
            right: 5px;
            color: white;
            background-color: red;
            border-radius: 5px;
            &:hover {
              opacity: 0.7;
            }
          }
        }
      }
      .logo {
        border: 1px solid #303030;
        border-radius: 5px;
        width: 100%;
        .main-title {
          margin-top: 20px;
          margin-bottom: -10px;
        }
        .main-logo-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          padding: 20px;
          .main-styles-container {
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 60%;
            .title-container {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }
          }
        }
        .styles-picker-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
        }
        .font-chooses-container {
          display: flex;
          flex-direction: row;
          width: 100%;
          gap: 10px;
          margin-top: 4px;
          justify-content: space-evenly;
          .font-style-container {
            background: #e5edff;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 4px;
            border: 1px solid #959595;
            border-radius: 5px;
            padding: 4px;
            width: 100%;
            .font-style {
              font-size: 18px;
              line-height: 24px;
              font-weight: 600;
              color: #474747;
            }
          }
        }
        .colors-container {
          display: flex;
          flex-direction: column;
          gap: 6px;
          .color {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: color;
            cursor: pointer;
            border: 1px #303030 solid;
            transition: border 0.3s ease;
          }
        }
        .final {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          width: 35%;
          height: 200px;
          .final-logo-container {
            background: radial-gradient(circle, #51aafd, #002d68);
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            padding: 40px;
            border-radius: 5px;
            width: 100%;
            overflow: hidden;
            .final-logo {
              font-weight: 700;
              line-height: 50px;
            }
          }
        }
      }
    }
  }
  .submit-btn {
    .MuiButton-root {
      width: 150px;
    }
  }
`;
